import { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";
import classNames from "classnames";

import { AscTooltipPropsI } from "./AscTooltip.type";
import styles from "./AscTooltip.module.scss";

function AscTooltip({
  place = "top",
  events = "hover",
  children,
  tooltipAnchor,
  tooltipAnchorClassName,
  className,
  tooltipContentClassName,
}: AscTooltipPropsI) {
  const [tooltipId, setTooltipId] = useState("");

  useEffect(() => {
    setTooltipId(`tooltip-${Math.floor(Math.random() * 1000000)}`);
  }, []);

  return (
    <div className={classNames(styles.element, className)}>
      <div
        data-tooltip-id={tooltipId}
        className={classNames(styles.anchor, tooltipAnchorClassName)}
      >
        {tooltipAnchor}
      </div>
      <Tooltip
        id={tooltipId}
        place={place}
        events={[events]}
        clickable
        className={classNames(styles.tooltip, tooltipContentClassName)}
      >
        {children}
      </Tooltip>
    </div>
  );
}

export default AscTooltip;
